import React from 'react'
import { ReactComponent as SignupCardIcon } from "../../../images/signup-card.svg"
import { ReactComponent as SignupNoCardIcon } from "../../../images/signup-nocard.svg"
import { Translation } from 'react-i18next';

import "./signup-choose.styles.scss"

export default function SignupChoose({ setType }) {
    return (
        <Translation>
            {t =>
                <div className="signup-choose">
                    <div className="signup-choose-card">
                        <div className="icon">
                            <SignupCardIcon title="without-card" />
                        </div>
                        <div className="card-content">
                            <div className="title">{t("signup.withFidelity")}</div>
                            <button className="cta" type="submit" onClick={() => setType("fetch")}>
                                <span>{t("signup.register")}</span>
                            </button>
                        </div>
                    </div>
                    <div className="signup-choose-card">
                        <div className="icon">
                            <SignupNoCardIcon title="with-card" />
                        </div>
                        <div className="card-content">
                            <div className="title">{t("signup.withoutFidelity")}</div>
                            <button className="cta" type="submit" onClick={() => setType("check")}>
                                <span>{t("signup.register")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            }
        </Translation>
    )
}
